
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class SummaryBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class SummaryBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u: string = data._id.match(/^sum-(.*)/i)[1];

    return {
      id:          data._id,
      seq:         parseInt(data.seq),
      name:        `${data.tx}`,
      hasChildren: args.hasChildren,
      isExpanded:  args.isExpanded,
      type:        'summary',
      children:    args.children,
      parent:      args.parent,
      kids:        data.ch,
      tags:        [],
      label:       data.lb,
      pkey:        data.pa,
      text:        data.tx,
      u
    };

  }
}
